import { render, staticRenderFns } from "./UsuariosClientePrincipal.vue?vue&type=template&id=57c3b652&"
import script from "./UsuariosClientePrincipal.vue?vue&type=script&lang=js&"
export * from "./UsuariosClientePrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports